export interface ILang {
	[key: string]: {
		text: string;
		lng: 'it' | 'en' | 'es' | 'fr' | 'de' | 'pt' | 'pl';
		icon: string;
	};
}

/**
 * Supported languages in display order:
 * Italiano, Inglese, Spagnolo, Francese, Tedesco, Portoghese, Polacco
 */
const LANG: ILang = {
	IT: {
		text: 'Italiano',
		lng: 'it',
		icon: 'CustomItaly',
	},
	EN: {
		text: 'English',
		lng: 'en',
		icon: 'CustomUsa',
	},
	ES: {
		text: 'Español',
		lng: 'es',
		icon: 'CustomSpain',
	},
	FR: {
		text: 'Français',
		lng: 'fr',
		icon: 'CustomFrance',
	},
	DE: {
		text: 'Deutsch',
		lng: 'de',
		icon: 'CustomGermany',
	},
	PT: {
		text: 'Português',
		lng: 'pt',
		icon: 'CustomPortugal',
	},
	PL: {
		text: 'Polski',
		lng: 'pl',
		icon: 'CustomPoland',
	},
};

export const getLangWithKey = (key: ILang['key']['lng']): ILang['key'] => {
	// @ts-ignore
	return LANG[Object.keys(LANG).filter((f) => key.includes(LANG[f].lng))];
};

export default LANG;
